export const getRouteUrl = ({ contractId, objectId, objectType, groupId, groupItemId }) => {
  return '/contracts/' + contractId + '/objects/' + objectId + '/' + objectType + (groupId ? '/' + groupId : '') + (groupItemId ? '/' + groupItemId : '');
};

export const getWatcherRouteUrl = ({ objectId, groupId, groupItemId }) => {
  return '/watcherObjects/' + objectId + '/UP/' + groupId + (groupItemId ? '/' + groupItemId : '');
};